import React from 'react';

import { DataGrid, GridColDef } from '@mui/x-data-grid';

import { API } from '@luxuryescapes/lib-types';

import GridPagination from '~/components/Common/Elements/GridPagination';
import { currencyFormatter } from '~/components/Experiences/helpers';

import { OrderStatusChip } from '../AllOrders/components/OrderStatusChip';
import { dateFormatter, orderLinkFormatter, userLinkFormatter } from '../formatters';

interface Props {
  page: number;
  total: number;
  sizePerPage: number;
  rerender: () => void;
  orders: Array<API.Order.Order>;
  onPageChange: (page: number) => void;
}

const columns: Array<GridColDef> = [
  { field: 'number', headerName: 'Booking ID', width: 150, sortable: false, display: 'flex' },
  {
    field: 'customer_email',
    headerName: 'Customer Email',
    sortable: false,
    flex: 1,
    renderCell: userLinkFormatter,
    display: 'flex',
  },
  { field: 'customer_full_name', headerName: 'Customer Name', flex: 1, sortable: false, display: 'flex' },
  {
    field: 'created_at',
    headerName: 'Order Placed',
    sortable: false,
    width: 200,
    renderCell: (params) => dateFormatter(params.value),
    display: 'flex',
  },
  {
    field: 'status',
    headerName: 'Order Status',
    width: 150,
    sortable: false,
    display: 'flex',
    renderCell: (params) => <OrderStatusChip orderStatus={params.row.status} />,
  },
  { field: 'brand', headerName: 'Brand', width: 150, sortable: false, display: 'flex' },
  { field: 'currency_code', headerName: 'Currency', sortable: false, display: 'flex' },
  {
    field: 'total',
    headerName: 'Order Total',
    sortable: false,
    width: 120,
    renderCell: (params) => currencyFormatter(params.row.currency_code, params.row.total, 2),
    display: 'flex',
  },
  {
    field: 'id',
    headerName: 'View Order',
    sortable: false,
    width: 120,
    renderCell: orderLinkFormatter,
    display: 'flex',
  },
];

export default function CarHirePurchaseList({ orders, total, page, sizePerPage, onPageChange }: Props) {
  return (
    <DataGrid
      rows={orders}
      rowCount={total}
      columns={columns}
      pagination
      paginationMode="server"
      paginationModel={{ page: page - 1, pageSize: sizePerPage }}
      pageSizeOptions={[sizePerPage]}
      onPaginationModelChange={({ page }) => onPageChange(page + 1)}
      slots={{ pagination: GridPagination }}
      disableColumnFilter
      disableColumnMenu
      disableRowSelectionOnClick
      autoHeight
    />
  );
}
